/**
 * The design's recurring looks, as class strings so a <button>, an <a> or a
 * <div> can wear them. Every value is lifted from the Agent Control Panel design.
 */

/** Uppercase mono captions: column heads, "RECENT", "CREDENTIALS". */
export const monoLabel = 'font-mono text-[10.5px] tracking-[.1em] text-mute';

/** The accent eyebrow above a page title: "AUDIT TRAIL", "DIAGNOSTICS". */
export const eyebrow = 'mb-1.5 font-mono text-[11.5px] tracking-[.12em] text-acc';

export const pageTitle = 'm-0 text-[28px] font-semibold tracking-[-.02em]';

export const card = 'rounded-2xl border border-line bg-surf';

/** A page section entering: the design's `rise` animation. */
export const rise = 'animate-rise';

export const button = {
  primary:
    'rounded-[10px] border-0 bg-acc px-4 py-2.5 text-[13.5px] font-semibold text-acc-ink transition-[transform,filter] duration-150 hover:-translate-y-px hover:brightness-[1.08] disabled:opacity-60',
  outline:
    'rounded-[10px] border border-line bg-transparent px-4 py-2.5 text-[13.5px] font-medium text-ink transition-colors hover:bg-surf2',
  ghostAccent:
    'rounded-[10px] border border-transparent bg-transparent px-4 py-2.5 text-[13.5px] font-medium text-acc transition-colors hover:bg-acc-soft',
  small:
    'rounded-[9px] border border-line bg-transparent px-3.5 py-2 text-[13px] text-ink transition-colors hover:bg-surf2',
  link: 'border-0 bg-transparent p-0 text-[13px] text-acc hover:text-ink',
  close:
    'grid size-8 place-items-center rounded-[9px] border border-line bg-transparent text-base text-mute hover:text-ink',
};

/** The small mono source tile (QM, EM, TG…) used in rows. */
export const glyphTile =
  'grid h-6 w-[34px] flex-none place-items-center rounded-md bg-surf2 font-mono text-[10px] font-medium';

/** A segmented control: the container, and one option on or off. */
export const segment = {
  group: 'flex gap-1 rounded-[10px] border border-line bg-surf p-1',
  on: 'rounded-[7px] border-0 bg-acc px-3 py-1.5 text-[13px] text-acc-ink transition-all',
  off: 'rounded-[7px] border-0 bg-transparent px-3 py-1.5 text-[13px] text-mute transition-all hover:text-ink',
};

/** A form field as the design's modals draw it: label above, muted, 12.5px. */
export const fieldLabel = 'flex flex-col gap-1.5 text-[12.5px] text-mute';

/** The text box inside it. Add `font-mono text-[13.5px]` for ids, keys and hosts. */
export const input =
  'w-full rounded-[9px] border border-line bg-surf2 px-3 py-2.5 text-sm text-ink placeholder:text-mute/70';

/** The numbered steps of a setup guide: "01", "02" in accent mono. */
export const guideNumber = 'pt-[3px] font-mono text-[11px] text-acc';

/** An error line under a form. */
export const formError = 'text-[12.5px] text-bad';
